import axiosInstance from "./../axiosInstance";
import { USER_ID } from "./../settings";

/**
 * Obtiene el plan disponible de cada estudiante
 * @returns 
 */
export const getSectionPlanByStudent = async () => {
    try {
        const url = `MeetScheduling/GetSessionPlanByStudent/${USER_ID}`;
        const axios = axiosInstance();
        const res = await axios.get(url);
        const data = await res.data;
        return {
            ok: true,
            data: data,
            hasSectionPlan: res.status !== 204
        };
    } catch (error) {
        return {
            ok: false,
            errorMessage: error,
        };
    }
};

/**
 * Este metodo devolverá, si el usuario tiene disponible plan o cupo para reservar una clase 
 * @returns un data con la propiedad : canScheduleMeet, si viene true podrá entrar a la ventana de agendamiento
 */
export const getIsAppointmentsAvailable = async () => {
    try {
        const url = `MeetScheduling/GetIsAppointmentsAvailable/${USER_ID}`;
        const axios = axiosInstance();
        const res = await axios.get(url);
        const data = await res.data;
        return {
            ok: true,
            data: data,
        };
    } catch (error) {
        return {
            ok: false,
            errorMessage: error,
        };
    }
};

